import {marketingTag} from "./progress"

const PROVIDERS = ["gmail", "outlook", "yahoo"]
const LABELS = ["Healthy", "Watch", "Act now"]
const TONES = ["green", "yellow", "red"]
const ACTIONS = {
  bounce: "Hold the ramp. Check where the addresses came from and import any suppressions you missed.",
  spam: "Cut that provider's share 25 to 30%. Find the stream or customer causing them and pause it.",
  deferrals: "Cut that provider's share 25 to 30% until it settles, then grow more slowly.",
  ok: "Stay on the ramp. These rates are inside the warm-up guide."
}

function bounceLevel(value) {
  if (value < 2) return 0
  if (value <= 5) return 1
  return 2
}

function spamLevel(value) {
  if (value < 0.1) return 0
  if (value < 0.3) return 1
  return 2
}

function providerLevel(bounce, spam, deferral, yahoo) {
  let level = Math.max(bounceLevel(bounce), spamLevel(spam))
  if (deferral === "lot") {
    level = Math.max(level, 1)
    if (yahoo) level = Math.min(2, level + 1)
  }
  return level
}

function healthScore(bounce, spam, deferral) {
  let score = 100
  if (bounce > 5) score -= 45
  else if (bounce >= 2) score -= 22
  if (spam >= 0.3) score -= 45
  else if (spam >= 0.1) score -= 22
  if (deferral === "lot") score -= 18
  else if (deferral === "little") score -= 8
  return Math.max(0, Math.min(100, score))
}

function worstSignal(bounce, spam, deferral) {
  if (bounce > 5) return "bounce"
  if (spam >= 0.3) return "spam"
  if (bounce >= 2) return "bounce"
  if (spam >= 0.1) return "spam"
  if (deferral === "lot") return "deferrals"
  return "ok"
}

function formatPct(value, digits) {
  return `${value.toFixed(digits)}%`
}

function paintArc(arc, score, level) {
  if (!arc) return
  arc.classList.remove("stroke-good", "stroke-warn", "stroke-bad")
  arc.classList.add(level >= 2 ? "stroke-bad" : level === 1 ? "stroke-warn" : "stroke-good")
  arc.setAttribute("stroke-dasharray", `${score} 100`)
}

function render(root) {
  const bounce = Number(root.querySelector("[data-learn-bounce]")?.value || 0)
  const spam = Number(root.querySelector("[data-learn-spam]")?.value || 0)
  const deferral = root.querySelector("[data-learn-deferral][aria-pressed='true']")?.dataset.learnDeferral || "flat"
  const score = healthScore(bounce, spam, deferral)
  const overall = Math.max(...PROVIDERS.map((key) => providerLevel(bounce, spam, deferral, key === "yahoo")))
  const bounceInput = root.querySelector("[data-learn-bounce]")
  const spamInput = root.querySelector("[data-learn-spam]")
  const bounceLabel = root.querySelector("[data-learn-bounce-label]")
  const spamLabel = root.querySelector("[data-learn-spam-label]")
  if (bounceLabel) bounceLabel.textContent = formatPct(bounce, 1)
  if (spamLabel) spamLabel.textContent = formatPct(spam, 2)
  if (bounceInput) bounceInput.setAttribute("aria-valuetext", `${formatPct(bounce, 1)}`)
  if (spamInput) spamInput.setAttribute("aria-valuetext", `${formatPct(spam, 2)}`)
  const scoreEl = root.querySelector("[data-learn-score]")
  if (scoreEl) scoreEl.textContent = String(score)
  const scoreLabel = root.querySelector("[data-learn-score-label]")
  if (scoreLabel) scoreLabel.textContent = LABELS[overall]
  const gauge = root.querySelector("[data-learn-gauge]")
  if (gauge) gauge.setAttribute("aria-label", `Sending health ${score} of 100, ${LABELS[overall].toLowerCase()}`)
  const needle = root.querySelector("[data-learn-needle]")
  if (needle) needle.style.transform = `rotate(${(score / 100) * 180 - 90}deg)`
  paintArc(root.querySelector("[data-learn-arc]"), score, overall)
  PROVIDERS.forEach((key) => {
    const row = root.querySelector(`[data-learn-provider='${key}']`)
    const wrap = row?.querySelector("[data-learn-provider-tag]")
    if (!wrap) return
    const level = providerLevel(bounce, spam, deferral, key === "yahoo")
    wrap.replaceChildren(marketingTag(LABELS[level], TONES[level], true))
  })
  const action = root.querySelector("[data-learn-action]")
  if (action) action.textContent = ACTIONS[worstSignal(bounce, spam, deferral)]
}

export function mount(root) {
  root.querySelector("[data-learn-bounce]")?.addEventListener("input", () => render(root))
  root.querySelector("[data-learn-spam]")?.addEventListener("input", () => render(root))
  const buttons = Array.from(root.querySelectorAll("[data-learn-deferral]"))
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((other) => other.setAttribute("aria-pressed", String(other === button)))
      render(root)
    })
  })
  render(root)
}
